import script from "./DayCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DayCard.vue?vue&type=script&setup=true&lang=js"

import "./DayCard.vue?vue&type=style&index=0&id=35a85e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a85e12"]])

export default __exports__